import LoyaltyBanner from "../../../LoyaltyBanner";
import keychainImage from "../../../LoyaltyBanner/Tier_3_Cluster.webp";
import PropTypes from "prop-types";
import { withTranslation } from "../../../translation";

const BannerContent = ({ formatTranslation, membersDayEvent }) => {
  const buttonUrl =
    "https://www.asos.com/discover/our-apps/?campaign=membersDay-plpBanner";
  const loyaltyCopyTranslation =
    membersDayEvent === "MembersSaleLive"
      ? "web_members_day_live_plp_banner_body_copy"
      : "web_members_day_plan_your_buy_banner_copy";

  return (
    <LoyaltyBanner
      header={formatTranslation("web_members_day_plp_banner_title")}
      copy={formatTranslation(loyaltyCopyTranslation)}
      buttonCopy={formatTranslation("web_members_day_plp_banner_button_copy")}
      buttonUrl={buttonUrl}
      imagePath={keychainImage}
    />
  );
};

BannerContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  membersDayEvent: PropTypes.string,
};

export default withTranslation(BannerContent);
